import { usePermissions } from 'react-admin';
import { PlatformRole, type PlatformRole as PlatformRoleValue } from './roles';

/**
 * True when the signed-in principal holds `platform:admin`. Route guards
 * and every write action (create/edit/delete/rotate buttons, forms) must
 * gate on this — `platform:auditor` is read-only everywhere, including the
 * audit log itself.
 */
export function useCanWrite(): boolean {
  const { permissions } = usePermissions<PlatformRoleValue[]>();
  if (!permissions) return false;
  return permissions.includes(PlatformRole.Admin);
}
